/* eslint-disable eqeqeq */
/* eslint-disable prefer-template */
/* eslint-disable prefer-const */
/* eslint-disable no-else-return */
/* eslint-disable no-debugger */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MultiSelect } from "react-multi-select-component";
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";
import clsx from "clsx";
import moment from "moment";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

import { CustomTab, Button } from "../../atomicComponents";
import {
  CustomFormGroup,
  CustomDatePicker
} from "../../components/FormComponents";
import { setLogin } from "../../redux/features/auth/actions";

import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex
} from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import BackButton from "../../components/BackButton/BackButton";
import styles from "./SPOCBCProjectWiseReport.module.css";
import MultiSelects from "../../components/FormComponents/MultiSelects";
import Truckloading from "../../components/CvLoader/Cvloader";

const SPOCBCProjectWiseReport = () => {
  const dispatchNew = useDispatch();
  const history = useHistory();
  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };
  // eslint-disable-next-line no-unused-vars
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const { userRole } = auth;
  const [bcInfo, setBcInfo] = useState([]);
  const [projectInfo, setProjectInfo] = useState([]);
  const [projectInfos, setProjectInfos] = useState([]);
  const [BarrelInfo, setBarrelInfo] = useState([]);
  const [BCSelected, setBCSelected] = useState([]);
  const [projectSelected, setProjectSelected] = useState([]);
  const [barrelSelected, setBarrelSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  const UserRoles = userRole;
  const MangerFlag = UserRoles.includes("M");
  const { showPopup } = usePopupManager();

  const LIFlag = UserRoles.includes("LI");
  const LIFlagOnly = UserRoles.includes("LI") && UserRoles.length === 1;
 
  const DSFlag = UserRoles.includes("DS");
  const SAFlag = UserRoles.includes("SA");
  let requiredUsers= ["M", "DS", "LI","SA"];

    const[userList,setUserList]=useState(UserRoles.filter(role => requiredUsers.includes(role)))

  const [projectOption] = useState([
    { value: "Projects", label: "Projects" },
    { value: "Indirect Projects", label: "Indirect Projects" }
  ]);
  const [BCOption] = useState([
    { value: 1, label: 1 },
    { value: 2, label: 2 }
  ]);
  const [myState, setState] = React.useState({
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    tableFlag: false,
    checkType4: "",
    checkType5: "",
    displayTrue: false,
    checkType6: "",
  });
  const handleSubmit = async () => {
    setState((prevState) => ({ ...prevState, tableFlag: true }));
  };
  const [proDetails, setProDetails] = useState("");

  console.log(bcInfo, "bcInfo");

  const handleSelect = () => {
    setState((prevState) => ({ ...prevState, checkFlag: true }));
  };

  const handleDate = (date, name) => {
    //  let newvalue = convert(date);
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;
    }
    const newDate = date.format(DATE_FORMAT.ISO);
    setState((prevData) => ({ ...prevData, [name]: date }));
  };

  const baseDefaultColumns = [
    {
      width: 160,
      title: "Project Code",
      field: "ProjectCode",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Project Description",
      field: "ProjectDescription",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Cost Center",
      field: "CostCenter",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Cost Center Description",
      field: "CostCenterDescription",
      enableSearch: true,
      enableFilter: true
    },

    {
      width: 140,
      title: "Employee Id",
      field: "EmployeeId",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Employee Name",
      field: "EmployeeName",
      enableSearch: true,
      enableFilter: true
    },

    {
      width: 140,
      title: "Grade Group",
      field: "GradeGroup",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Month-Year",
      field: "MonthYear",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "Booked Hrs",
      field: "BookedHrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "From Date",
      field: "fromDate",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 140,
      title: "To Date",
      field: "toDate",
      enableSearch: true,
      enableFilter: true
    }
  ];

  useEffect(()=>{
    if(userList?.length === 1){
      setState((prev) => ({
        ...prev,
        checkType4:userList[0]
      }));
    }
    if(userList?.length===1 && userList[0]==="LI")
    {
      setState((prev) => ({
        ...prev,
        checkType5:"A",
        displayTrue:true,
        checkType6:"S"
      }));
    }
  },[userList])
  

  const ROW_HEIGHT = 38;
  
  const handleCheck5 = (e) => {
    setState((prev) => ({
      ...prev,
      checkType5: e.target.value,
      displayTrue: true
    }));
    setBCSelected([])
    setBarrelSelected([])
    setProjectSelected([])
    setProjectInfo([])
    setProjectInfos([])
    setState((pre)=>({
      ...pre,
      fromDate:null,
      toDate:null

    }))
  };

  const handleCheck6 = (e) => {
    setState((prev) => ({
      ...prev,
      checkType6: e.target.value,
      displayTrue: true
    }));
    setBCSelected([])
    setBarrelSelected([])
    setProjectSelected([])
    setProjectInfo([])
    setProjectInfos([])
    setState((pre)=>({
      ...pre,
      fromDate:null,
      toDate:null

    }))
  };

  const handleCheck4 = (e) => {
    setState((prev) => ({
      ...prev,
      checkType4: e.target.value,
      displayTrue: true
    }));
    setBCSelected([])
    setBarrelSelected([])
    setProjectSelected([])
    setProjectInfo([])
    setProjectInfos([])
        if(e.target.value==="LI"){
      setState((pre)=>({
        ...pre,
        fromDate:null,
        toDate:null,
        checkType5:"A",
        checkType6:"S"
      }))
    }
    else{
      setState((pre)=>({
        ...pre,
        fromDate:null,
        toDate:null,
        checkType5:"",
        checkType6:""
      }))
    }
  };

  const exportExcel = async (excelRowData) => {

    let fileName = "Project Wise Report" + moment().format("DD/MM/YYYY LT");
    
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelRowData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.csv`);

  }

  const getBcInformation = (role) => {
    setLoading(true)
    const apiFormatedData = {
      stremp_login: auth.personNumber,
      strco_code: auth.companyCode,
      user_role: role
    };

    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/ProjectWiseBCDropdown`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoading(false);
          }
          return response.json();
      })
      .then((responseJson) => {
        if (
          responseJson.msg === "Success" &&
          responseJson?.data?.length !== 0
        ) {
          setLoading(false)
          const transformedDataBcs = responseJson.data?.map(
            ({ bc_code, bc_desc }) => ({
              label: bc_desc,
              value: bc_code
            })
          );
          setBcInfo(transformedDataBcs);
        }
        if (
          responseJson.msg === "Success" &&
          responseJson?.data?.length === 0
        ) {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found"
          });
        }
        if (responseJson.msg === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Something Went Wrong"
          });
        }
      })
      .catch((error) => {
        setLoading(false)
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Internal server error"
        });
      });
  };


  const getProjectInformation = (transformedDataBarrel) => {

    let concatedBarrrel=transformedDataBarrel?.map((data)=>data.value).join(",")
    setLoading(true)
    const apiFormatedData = {
      stremp_login: auth.personNumber,
      strco_code: auth.companyCode,
      user_role: myState.checkType4,
      barrel:concatedBarrrel
    };

    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/ProjectWiseProjectDropdown`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoading(false);
          }
          return response.json();
      })
      .then((responseJson) => {
        if (responseJson.msg === "Success" && responseJson?.data?.length) {
          setLoading(false)
          const transformedDataProjects = responseJson.data?.map(
            ({ project_def, project_desc }) => ({
              label: project_desc,
              value: project_def
            })
          );
          setProjectInfo(transformedDataProjects);
          setProjectInfos(transformedDataProjects);
        } else if (
          responseJson.msg === "Success" &&
          responseJson?.data?.length === 0
        ) {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found"
          });
          setProjectInfo([])
          setProjectInfos([])
        } else if (responseJson.msg === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Something Went Wrong"
          });
        }
      })
      .catch((error) => {
        setLoading(false)
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Internal server error"
        });
      });
  };

  useEffect(()=>{
    if(barrelSelected?.length !== 0){
      getProjectInformation(barrelSelected);
    }
   if(barrelSelected?.length == 0){
      setProjectInfo([])
      setProjectSelected([])
    } 
  },[barrelSelected])

  const getBarrelInformation = (role) => {
    setLoading(true)
    const apiFormatedData = {
      stremp_login: auth.personNumber,
      strco_code: auth.companyCode,
      user_role: role
    };

    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/ProjectWiseBarrelDropdown`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.msg === "Success" && responseJson?.data?.length !== 0) {
          setLoading(false)
          const transformedDataBcs = responseJson.data?.map(
            ({ code_code, barrel_desc }) => ({
              label: barrel_desc,
              value: code_code
            })
          );
  
          setBarrelInfo(transformedDataBcs);
        } else if (
          responseJson.msg === "Success" &&
          responseJson?.data?.length === 0
        ) {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found"
          });
        } else if (responseJson.msg === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Something Went Wrong"
          });
        }
      })
      .catch((error) => {
        setLoading(false)
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Internal server error"
        });
      });
  };

  useEffect(() => {
    if (myState.checkType4 !=='') {
      getBcInformation(myState.checkType4);
      getBarrelInformation(myState.checkType4);
    }
  }, [myState.checkType4]);



  const renderHTML = () => (
    <div className={styles.formGroup}>
      {userList?.length >1 &&
      <Grid
        container
        spacing={0}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        {MangerFlag ? (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType4}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck4}
              >
                <FormControlLabel
                  value="M"
                  name="status4"
                  label="Manager"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        ) : (
          ""
        )}

        {LIFlag ? (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType4}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck4}
              >
                <FormControlLabel
                  value="LI"
                  name="status4"
                  label="Linkage SPOC"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        ) : (
          ""
        )}

        {DSFlag ? (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType4}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck4}
              >
                <FormControlLabel
                  value="DS"
                  name="status4"
                  label="Departmental SPOC"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        ) : (
          ""
        )}

        {SAFlag ? (
          <>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              required={true}
              value={myState.checkType4}
              style={{
                marginLeft: "27px",
                marginRight: "20px"
              }}
              onChange={handleCheck4}
            >
              <FormControlLabel
                value="SA"
                name="status4"
                label="Super Admin"
                control={<Radio size="small" />}
              />
            </RadioGroup>
          </>
        ) : (
          ""
        )}
      </Grid>
        }
      <Grid
        container
        spacing={0}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        {myState.checkType4 ==='LI' ? (
          ""
        ) : (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType5}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck5}
              >
                <FormControlLabel
                  value="A"
                  name="status4"
                  label="Approval Date"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        )}

        {myState.checkType4 ==='LI' ? (
          ""
        ) : (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType5}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck5}
              >
                <FormControlLabel
                  value="B"
                  name="status4"
                  label="Booking Date"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        )}
      </Grid>
      {myState.checkType4 ==='LI' ? (
          ""
        ) : (
        <>
        <Grid
        container
        spacing={0}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
       
        
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType6}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck6}
              >
                <FormControlLabel
                  value="S"
                  name="status4"
                  label="Summary"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType6}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck6}
              >
                <FormControlLabel
                  value="D"
                  name="status4"
                  label="Detail"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
        
      
      </Grid>
        </>
      )}
    </div>
  );

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      //  return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29

      return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  };

  const exportToExcel = (role) => {
    setLoading(true);
    let fromDate = convert2(myState.fromDate);
    let toDate = convert2(myState.toDate);

   
    if (myState.checkType4==null || myState.checkType4==="") {
      setLoading(false);
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please Select Role"
      });
      return;
    }

    if (myState.checkType5==null || myState.checkType5==="") {
      setLoading(false);
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please Select Approving Date Or Booking Date"
      });
      return;
    }

    if (myState.checkType6==null || myState.checkType6==="") {
      setLoading(false);
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please Select Summary or Detail"
      });
      return;
    }

    if (fromDate === "" || toDate === "") {
      setLoading(false);
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please Enter a date"
      });
      return;
    }

    const isSameOrAfter = moment(fromDate).isAfter(toDate);

    if (isSameOrAfter) {
      setLoading(false);
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "End Date Should Be Greater Than  Or Equal To Start Date"
      });
      return;
    }
 
    let commaBcsValue=BCSelected?.map((data)=>data.value).join(",")
    let commaProjectValue=projectSelected?.map((data)=>data.value).join(",")
    let projectAll=projectInfos?.map((data)=>data.value).join(",")
    console.log(projectSelected?.length==0, projectAll, commaProjectValue,"847")
    let apiFormatedData={

    }
    if(barrelSelected.length==0){
      apiFormatedData = {
        flag: myState.checkType5,
        rpttype: myState.checkType6,
        bc_no: commaBcsValue ==="" ? null :  commaBcsValue,
        proj_no: null,
        dtfrom: moment(fromDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
        dtto: moment(toDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
        role:myState.checkType4,
        pers_no: auth.personNumber
      };
    }
    if(barrelSelected.length!==0){
      apiFormatedData = {
        flag: myState.checkType5,
        rpttype: myState.checkType6,
        bc_no: commaBcsValue ==="" ? null :  commaBcsValue,
        proj_no: projectSelected?.length==0  ? projectAll  : commaProjectValue,
        dtfrom: moment(fromDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
        dtto: moment(toDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
        role:myState.checkType4,
        pers_no: auth.personNumber
      };
    }
    

    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/ProjectWiseBookingReport`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
          let responsecode=response.status
          if(responsecode===403){
           setLoading(false);
          }
          return response.json();
      })
      .then((responseJson) => {
        if (  responseJson.msg === "Success" &&    responseJson?.data?.length !== 0 ) {
        setLoading(false)
      //  if((myState.checkType6==="S")){
        if((myState.checkType4==="LI")){
        let excelRow = responseJson.data.map(({
              applied_date,
              approval_date,
              bc_name,
              bc_number ,
              booked_hours,
              booking_date,
              booking_status,
              employee_name,
              employee_no,
              grade_group,
              hrs_available_for_booking,
              location,
              manager_id,
              manager_name,
              project_definition,
              project_description,
              truncated_hours,
              month,
              gate,
              mfl,
              status, // Added for CHG0073013
              manager_review_status,
              review_by_number,
              review_by_name,


          }) => {
              let obj = {
                "Bc Number": bc_number,
                "Bc Name": bc_name,
                "Employee No": employee_no,
                "Employee Name": employee_name,
                "Grade Group": grade_group,
                // "Manager Id":manager_id,
                // "Manager Name":manager_name,
                "Project Number":project_definition,
                "Project Description":project_description,
                "Gate (EVM Activity)":gate,
                "Module (MFL)":mfl,
                "Month":month,
                "Truncated Hours":truncated_hours,
                "Status":status, // Added for CHG0073013
                // "Booking Date": booking_date,
                // "Hrs available for booking": hrs_available_for_booking,
                // "Applied Date": applied_date,
                // "Approval Date": approval_date, 
                // "Booked Hours": booked_hours,  
                // "Location":location,
                // "Booking Status": booking_status,
                // "Manager Review Status":manager_review_status,
                // "Review By Number ":review_by_number,
                // "Review By Name ":review_by_name,
              }
              return obj;
  
          }
          );
          exportExcel(excelRow)
          }
          else if(myState.checkType6==="S" && myState.checkType4 !=="LI"){
            let excelRow = responseJson.data.map(({
              applied_date,
              approval_date,
              bc_name,
              bc_number ,
              booked_hours,
              booking_date,
              booking_status,
              employee_name,
              employee_no,
              grade_group,
              hrs_available_for_booking,
              location,
              manager_id,
              manager_name,
              project_definition,
              project_description,
              truncated_hours,
              gate,mfl,bu,sub_bu,
              vehicle_type,
              month,
              vehicle_family,
              manager_review_status,
              review_by_number,
              review_by_name,
              status // Added for CHG0073013
  
          }) => {
  
  
            let obj = {
              "Bc Number": bc_number,
              "Bc Name": bc_name,
              "Employee No": employee_no,
              "Employee Name": employee_name,
              "Grade Group": grade_group,
              "Manager Id":manager_id,
              "Manager Name":manager_name,
              "Project Number":project_definition,
              "Project Description":project_description,
              // 'BU':bu,
              // "Sub Bu":sub_bu,
              // "Vehicle Type":vehicle_type,
              // "Vehicle Family":vehicle_family,
              // "Gate (EVM Activity)":gate,    
              // "Module (MFL)":mfl,
              "Booking Date": booking_date,
              "Hrs available for booking": hrs_available_for_booking,
              "Applied Date": applied_date,
              "Approval Date": approval_date, 
              "Booked Hours": booked_hours,  
              "Truncated Hours":truncated_hours,
              "Location":location,
              "Booking Status": booking_status,
              "Manager Review Status":manager_review_status,
              "Review By Number ":review_by_number,
              "Review By Name ":review_by_name,
              "Status":status // Added for CHG0073013
            }
            return obj;
  
          }
          );
          exportExcel(excelRow)

          }
          else{
            let excelRow = responseJson.data.map(({
              applied_date,
              approval_date,
              bc_name,
              bc_number ,
              booked_hours,
              booking_date,
              booking_status,
              employee_name,
              employee_no,
              grade_group,
              hrs_available_for_booking,
              location,
              manager_id,
              manager_name,
              project_definition,
              project_description,
              truncated_hours,
              gate,mfl,bu,sub_bu,vehicle_type,month,vehicle_family,Review_By_Number,Review_By_Name,Manager_Review_Status,
              status // Added for CHG0073013
  
          }) => {
  
  
            let obj = {
              "Bc Number": bc_number,
              "Bc Name": bc_name,
              "Employee No": employee_no,
              "Employee Name": employee_name,
              "Grade Group": grade_group,
              "Manager Id":manager_id,
              "Manager Name":manager_name,
              "Project Number":project_definition,
              "Project Description":project_description,
              'BU':bu,
              "Sub Bu":sub_bu,
              "Vehicle Type":vehicle_type,
              "Vehicle Family":vehicle_family,
              "Gate (EVM Activity)":gate,    
              "Module (MFL)":mfl,
              "Booking Date": booking_date,
              "Hrs available for booking": hrs_available_for_booking,
              "Applied Date": applied_date,
              "Approval Date": approval_date, 
              "Booked Hours": booked_hours,  
              "Truncated Hours":truncated_hours,
              "Location":location,
              "Booking Status": booking_status,
              "Manager Review Status":Manager_Review_Status,
              "Review By Number ":Review_By_Number,
              "Review By Name ":Review_By_Name,
              "Status":status // Added for CHG0073013
               
               
            }
            return obj;
  
          }
          );
          exportExcel(excelRow)
          }
          // window.location.reload()

        
         
        }
        if (   responseJson.msg === "Success" &&   responseJson?.data?.length === 0  ) {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
            reloads:true
          });
         
        }
        if (responseJson.msg === "Fail") {
          setLoading(false)
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Something Went Wrong"
          });
        }
      })
      .catch((error) => {
        setLoading(false)
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Internal server error"
        });
      });
  };

  const handleCancel = () => {
    window.location.reload();
  };

  const renderDropdDown = () => (
    <>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>BC Number</span>
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <MultiSelects
            className={clsx(styles.select, styles.sel2)}
            isMulti
            isClearable
            value={BCSelected}
            options={bcInfo}
             onChange={(selectedOption) => {
             setBCSelected(selectedOption);
             }}
            hasSelectAll={false}
            placeholder='All' 
            width="389px"
            name="bc_def"
          />
        </Grid>
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Barrel</span>
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <MultiSelects
            className={clsx(styles.select, styles.sel2)}
            isMulti
            isClearable
            value={barrelSelected}
            options={BarrelInfo}
            onChange={(selectedOption) => {
              setBarrelSelected(selectedOption);
            }}
            hasSelectAll={false}
            placeholder='All' 
            width="389px"
            name="Barrel_def"
          />
        </Grid>
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>Project</span>
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <MultiSelects
            className={clsx(styles.select, styles.sel2)}
            isMulti
            isClearable
            value={projectSelected}
            options={projectInfo}
            onChange={(selectedOption) => {
              setProjectSelected(selectedOption);
            }}
            hasSelectAll={false}
            placeholder='All' 
            width="389px"
            name="Project_def"
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>From Date</span>
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <CustomDatePicker
            // onError={dateValidation}
            autoOk
            clearable
            inputVariant="outlined"
            value={myState.fromDate}
            onChange={(e) => {
              handleDate(e, "fromDate");
            }}
            inputProps={{
              className: clsx(styles.select, styles.dateInput)
            }}
            emptyLabel="dd/mm/yyyy"
            // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
            // minDate={moment(startDate, "YYYY-MM-DD").add(1, 'days')}
            format="DD/MM/yyyy"
            data-testid="date-picker-div-1"
            style={{ width: "100%" }}
            //  maxDate={moment().toDate()}
          />
        </Grid>
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <span>To Date</span>
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.formDiv}>
            <CustomDatePicker
              // onError={dateValidation}
              autoOk
              clearable
              inputVariant="outlined"
              value={myState.toDate}
              onChange={(e) => {
                handleDate(e, "toDate");
              }}
              inputProps={{
                className: clsx(styles.select, styles.dateInput)
              }}
              emptyLabel="dd/mm/yyyy"
              // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
              // minDate={moment(startDate, "YYYY-MM-DD").add(1, 'days')}
              format="DD/MM/yyyy"
              data-testid="date-picker-div-1"
              style={{ width: "100%" }}
              //  maxDate={moment().toDate()}
            />
          </div>
        </Grid>

        <Grid item md={12} lg={12} sm={12}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => exportToExcel(myState.checkType4)}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginLeft: "389px" ,marginTop:'20px'}}
              >
                Export To Excel
              </Button>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="primary"
                onClick={() => handleCancel()}
                data-testid="confirm-action"
                 style={{ marginRight: "575px",marginTop:'20px' }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Report" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar} style={{}}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Rutuja",
                  "SAP ID": 122366,
                  "BC No": "122366",
                  LOC: "Research Center"
                }
              ]}
            />
          </div>
        </div>
        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup header="Project Wise Report" body={renderHTML()} />
          {myState.displayTrue && renderDropdDown()}
        </div>
        {loading ?
         <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
         <Truckloading />
         </div>:""}
      </div>
    </>
  );
};

export default SPOCBCProjectWiseReport;
